module.exports = __webpack_public_path__ + "media/images/symbol-defs-a42218099fe4a2aa9ee5b74a8fc52d83.svg";